import React from "react";
import GradeAttributeCard from "../GradeAttributeCard";
import { RenderListWrapper } from "./styles";

function RenderList({ list }) {
  if (!list) return;
  return (
    <RenderListWrapper>
      {list.map((item) => (
        <GradeAttributeCard
          key={item?.disease}
          title={item?.disease}
          limit={item?.limit}
          remarks={item?.remarks}
        />
      ))}
    </RenderListWrapper>
  );
}

export default RenderList;
